module.exports = __webpack_public_path__ + "3cdf602b3281ee10ef3c7260cafd634f.otf";